import MarketPrices from "./MarketPrices";

export default MarketPrices;
